module.exports = __webpack_public_path__ + "img/field_blend_dough2.71023d12.jpg";